// extracted by mini-css-extract-plugin
export var arrow = "PseudoLink-module--arrow--65aa5";
export var arrowNo = "PseudoLink-module--arrow_no--fdccd";
export var arrowYes = "PseudoLink-module--arrow_yes--2ea2b";
export var flex = "PseudoLink-module--flex--60797";
export var flex1 = "PseudoLink-module--flex_1--15813";
export var flexCenter = "PseudoLink-module--flex_center--286a4";
export var flexCenterCol = "PseudoLink-module--flex_center_col--f2912";
export var flexCol = "PseudoLink-module--flex_col--a58a9";
export var flexFixCenterCol = "PseudoLink-module--flex_fix_center_col--7ad3a";
export var flexFixedCenterCol = "PseudoLink-module--flex_fixed_center_col--5eb2f";
export var pseudoLink = "PseudoLink-module--pseudoLink--08e10";
export var rotating = "PseudoLink-module--rotating--2b6a2";